import { render, staticRenderFns } from "./AddCompliance.vue?vue&type=template&id=ca80bb1a&scoped=true"
import script from "./AddCompliance.vue?vue&type=script&lang=js"
export * from "./AddCompliance.vue?vue&type=script&lang=js"
import style0 from "./AddCompliance.vue?vue&type=style&index=0&id=ca80bb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca80bb1a",
  null
  
)

export default component.exports